export default "__VITE_ASSET__0f7b6fdf__"